/* ==========================================================================
   Compare Bikes (FAT-257)
   The bike pool is fetched from the pool collection's ?view=compare-json
   feed (250 per page), filtered by the current product type — so the
   auto-populated columns (top bikes in the collection's own sort order,
   e.g. best-selling) and the drawer's brand tiles (vendors present in the
   pool, logos from the `merk` metaobject) stay dynamic with zero
   per-product setup. The drawer's search goes wider: it queries the
   storewide predictive search API, so any product on the site (fatbike,
   vouwfiets, e-bike, …) can be found and compared — its column data is
   fetched on demand from /products/<handle>?view=compare-json. A "kies je
   fatbike" picker switches to manual mode (auto columns are cleared) so
   the visitor composes their own comparison.
   ========================================================================== */
(function () {
  'use strict';

  function initSection(section) {
    if (section.__compareBikesInit) return;
    section.__compareBikesInit = true;

    var dataEl = section.querySelector('[data-compare-data]');
    var scroller = section.querySelector('[data-compare-scroll]');
    var slotsWrap = section.querySelector('[data-compare-slots]');
    var slotTemplate = section.querySelector('template[data-compare-slot]');
    var thumb = section.querySelector('.custom-scrollbar-thumb');
    if (!dataEl || !scroller || !slotsWrap || !slotTemplate) return;

    var config;
    try {
      config = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var candidates = [];
    var byHandle = {};

    var rows = Array.prototype.slice.call(section.querySelectorAll('[data-compare-row]'));
    var state = { mode: 'auto', added: [] };

    /* --- Column building --------------------------------------------------- */

    function el(tag, className, text) {
      var node = document.createElement(tag);
      if (className) node.className = className;
      if (text) node.textContent = text;
      return node;
    }

    function buildCell(row, candidate, isAuto) {
      var type = row.getAttribute('data-compare-row');
      var cell;

      if (type === 'head') {
        cell = el('div', 'compare-bike-header');
        if (!isAuto) {
          var removeBtn = el('button', 'compare-bike-remove');
          removeBtn.type = 'button';
          removeBtn.setAttribute('aria-label', config.labels.remove);
          removeBtn.innerHTML =
            '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 256 256" fill="currentColor"><path d="M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z"></path></svg>';
          removeBtn.addEventListener('click', function () {
            removeColumn(candidate.handle);
          });
          cell.appendChild(removeBtn);
        }
        var link = el('a', 'compare-bike-header-link');
        link.href = candidate.url;
        if (candidate.image) {
          var img = el('img');
          img.src = candidate.image;
          img.alt = candidate.imageAlt || candidate.title;
          img.loading = 'lazy';
          link.appendChild(img);
        }
        link.appendChild(document.createTextNode(candidate.title));
        cell.appendChild(link);
      } else if (type === 'price') {
        cell = el('div', 'compare-bike-price info-block-item');
        cell.innerHTML = candidate.priceHtml;
        var cta = el('a', null, config.labels.linkText);
        cta.href = candidate.url;
        cell.appendChild(cta);
      } else {
        var index = parseInt(row.getAttribute('data-spec-index'), 10) || 0;
        cell = el('div', 'compare-bike-spec info-block-item');
        cell.appendChild(el('p', 'compare-bike-info-text', candidate.specs[index] || ''));
      }

      cell.setAttribute('data-compare-col', candidate.handle);
      if (isAuto) cell.setAttribute('data-compare-auto', 'true');
      return cell;
    }

    function addColumn(candidate, isAuto) {
      rows.forEach(function (row) {
        var cell = buildCell(row, candidate, isAuto);
        if (row.getAttribute('data-compare-row') === 'head') {
          row.insertBefore(cell, slotsWrap);
        } else {
          row.appendChild(cell);
        }
      });
      state.added.push({ handle: candidate.handle, auto: isAuto });
      refresh();
    }

    function removeColumn(handle) {
      section.querySelectorAll('[data-compare-col="' + handle + '"]').forEach(function (cell) {
        cell.remove();
      });
      state.added = state.added.filter(function (entry) {
        return entry.handle !== handle;
      });
      refresh();
    }

    function clearAutoColumns() {
      section.querySelectorAll('[data-compare-auto="true"]').forEach(function (cell) {
        cell.remove();
      });
      state.added = state.added.filter(function (entry) {
        return !entry.auto;
      });
    }

    /* --- "Kies je fatbike" picker (manual mode) ----------------------------- */

    function onPick(handle) {
      var candidate = byHandle[handle];
      if (!candidate) return;
      var alreadyAdded = state.added.some(function (entry) {
        return entry.handle === handle;
      });
      if (alreadyAdded) return;

      if (state.mode === 'auto') {
        // First manual pick switches to manual mode: auto slots go blank.
        clearAutoColumns();
        state.mode = 'manual';
      }
      addColumn(candidate, false);
    }

    function renderSlot() {
      slotsWrap.innerHTML = '';
      var total = 1 + state.added.length;
      // In auto mode the slot always shows: the first pick clears the auto
      // columns, so there is always room for a manual comparison.
      if (state.mode !== 'auto' && total >= config.maxColumns) return;

      var slot = slotTemplate.content.firstElementChild.cloneNode(true);
      var openBtn = slot.querySelector('[data-compare-open-drawer]');
      if (openBtn) openBtn.addEventListener('click', openDrawer);
      slotsWrap.appendChild(slot);
    }

    /* --- "Kies je fatbike" side drawer --------------------------------------
       Brand tiles and the brand-filtered bike list come from the
       type-filtered pool; the search input queries the whole store. */

    var drawer = section.querySelector('[data-compare-drawer]');
    var drawerOverlay = section.querySelector('[data-compare-drawer-overlay]');
    var drawerCloseBtn = section.querySelector('[data-compare-drawer-close]');
    var drawerSearch = section.querySelector('[data-compare-search]');
    var drawerBrands = section.querySelector('[data-compare-brands]');
    var drawerResults = section.querySelector('[data-compare-results]');
    var drawerBikesWrap = section.querySelector('[data-compare-bikes]');
    var drawerBackBtn = section.querySelector('[data-compare-back]');
    var drawerBackLabel = section.querySelector('[data-compare-back-label]');
    var drawerEmpty = section.querySelector('[data-compare-empty]');
    var bikeTiles = [];
    var searchTiles = [];
    var backLabelDefault = drawerBackLabel ? drawerBackLabel.textContent : '';

    function buildBikeTile(candidate) {
      var tile = el('button', 'compare-bikes-drawer-bike');
      tile.type = 'button';
      tile.setAttribute('data-compare-pick', candidate.handle);
      tile.setAttribute('data-vendor', candidate.vendor || '');
      if (candidate.thumb) {
        var img = el('img', 'compare-bikes-drawer-bike-img');
        img.src = candidate.thumb;
        img.alt = candidate.imageAlt || candidate.title;
        img.loading = 'lazy';
        tile.appendChild(img);
      }
      var info = el('span', 'compare-bikes-drawer-bike-info');
      info.appendChild(el('span', 'compare-bikes-drawer-bike-title', candidate.title));
      var price = el('span', 'compare-bikes-drawer-bike-price');
      price.innerHTML = candidate.drawerPriceHtml || candidate.priceHtml || '';
      info.appendChild(price);
      tile.appendChild(info);
      return tile;
    }

    /* Brand logos differ wildly in aspect ratio (square badges vs. wide
       wordmarks), so a shared bounding box alone still renders squarish
       logos visually much bigger. Scale each logo's height from its
       intrinsic ratio so they all get roughly the same visual area. */
    var LOGO_TARGET_AREA = 3000; /* px² inside the 140x44 logo box */
    function normalizeLogoSize(logo) {
      if (!logo.naturalWidth || !logo.naturalHeight) return;
      var ratio = logo.naturalWidth / logo.naturalHeight;
      var height = Math.sqrt(LOGO_TARGET_AREA / ratio);
      logo.style.height = Math.max(20, Math.min(44, height)) + 'px';
    }

    function renderDrawer() {
      if (!drawerBrands || !drawerBikesWrap) return;
      drawerBrands.innerHTML = '';
      /* Deliberately not clearing search tiles: this now runs on the first
         drawer open, and the visitor may already have typed a query while the
         pool was still loading. The pool tiles are appended hidden, so live
         search results stay on screen. */
      bikeTiles.forEach(function (tile) {
        tile.remove();
      });
      bikeTiles = [];

      /* Brands keep their order of first appearance in the pool: the pool
         collection is sorted by best-selling, so this is the best-selling
         brand order. */
      var vendors = [];
      var logoByVendor = {};
      candidates.forEach(function (candidate) {
        if (!candidate.vendor) return;
        if (vendors.indexOf(candidate.vendor) === -1) vendors.push(candidate.vendor);
        if (candidate.vendorLogo && !logoByVendor[candidate.vendor]) {
          logoByVendor[candidate.vendor] = candidate.vendorLogo;
        }
      });

      vendors.forEach(function (vendor) {
        var brandBtn = el('button', 'compare-bikes-drawer-brand');
        brandBtn.type = 'button';
        brandBtn.setAttribute('data-compare-brand', vendor);
        if (logoByVendor[vendor]) {
          var logo = el('img', 'compare-bikes-drawer-brand-logo');
          logo.alt = vendor;
          logo.loading = 'lazy';
          logo.addEventListener('load', function () {
            normalizeLogoSize(logo);
          });
          logo.src = logoByVendor[vendor];
          brandBtn.appendChild(logo);
        } else {
          brandBtn.appendChild(el('span', 'compare-bikes-drawer-brand-name', vendor));
        }
        drawerBrands.appendChild(brandBtn);
      });

      candidates.forEach(function (candidate) {
        var tile = buildBikeTile(candidate);
        tile.hidden = true;
        drawerBikesWrap.appendChild(tile);
        bikeTiles.push(tile);
      });
    }

    function filterBikeTiles(matcher) {
      clearSearchTiles();
      var visible = 0;
      bikeTiles.forEach(function (tile) {
        var addedAlready = state.added.some(function (entry) {
          return entry.handle === tile.getAttribute('data-compare-pick');
        });
        var show = !addedAlready && matcher(tile);
        tile.hidden = !show;
        if (show) visible++;
      });
      if (drawerEmpty) drawerEmpty.hidden = visible > 0;
    }

    /* --- Storewide search: predictive search API + on-demand column data ---- */

    var searchSeq = 0;
    var searchTimer = null;

    function clearSearchTiles() {
      searchTiles.forEach(function (tile) {
        tile.remove();
      });
      searchTiles = [];
    }

    function fetchCandidate(handle) {
      if (byHandle[handle]) return Promise.resolve(byHandle[handle]);
      return fetch('/products/' + handle + '?view=compare-json')
        .then(function (response) {
          if (!response.ok) throw new Error('compare-json ' + response.status);
          return response.json();
        })
        .then(function (item) {
          byHandle[item.handle] = item;
          return item;
        })
        .catch(function () {
          return null;
        });
    }

    function searchStore(query) {
      var seq = ++searchSeq;
      var url =
        '/search/suggest.json?q=' +
        encodeURIComponent(query) +
        '&resources[type]=product' +
        '&resources[limit]=10' +
        '&resources[options][unavailable_products]=hide' +
        '&resources[options][fields]=title,product_type,variants.title,vendor';

      fetch(url)
        .then(function (response) {
          if (!response.ok) throw new Error('suggest ' + response.status);
          return response.json();
        })
        .then(function (data) {
          var results =
            (data.resources && data.resources.results && data.resources.results.products) || [];
          var handles = results
            .map(function (result) {
              return result.handle;
            })
            .filter(function (handle) {
              return handle && handle !== config.currentHandle;
            });
          return Promise.all(handles.map(fetchCandidate));
        })
        .then(function (items) {
          if (seq !== searchSeq) return; // a newer query is in flight
          bikeTiles.forEach(function (tile) {
            tile.hidden = true;
          });
          clearSearchTiles();
          var visible = 0;
          items.filter(Boolean).forEach(function (candidate) {
            var addedAlready = state.added.some(function (entry) {
              return entry.handle === candidate.handle;
            });
            if (addedAlready) return;
            var tile = buildBikeTile(candidate);
            drawerBikesWrap.appendChild(tile);
            searchTiles.push(tile);
            visible++;
          });
          if (drawerEmpty) drawerEmpty.hidden = visible > 0;
          showResults();
        })
        .catch(function () {
          /* Search unavailable: keep whatever is on screen. */
        });
    }

    function showBrandGrid() {
      clearSearchTiles();
      if (drawerBrands) drawerBrands.hidden = false;
      if (drawerResults) drawerResults.hidden = true;
      if (drawerBackLabel) drawerBackLabel.textContent = backLabelDefault;
    }

    function showResults() {
      if (drawerBrands) drawerBrands.hidden = true;
      if (drawerResults) drawerResults.hidden = false;
    }

    function openDrawer() {
      if (!drawer) return;
      ensureDrawerContent();
      if (drawerSearch) drawerSearch.value = '';
      showBrandGrid();
      drawer.classList.add('is-open');
      drawerOverlay.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('compare-bikes-drawer-open');
    }

    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawerOverlay.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('compare-bikes-drawer-open');
    }

    if (drawer) {
      if (drawerOverlay) drawerOverlay.addEventListener('click', closeDrawer);
      if (drawerCloseBtn) drawerCloseBtn.addEventListener('click', closeDrawer);
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
      });

      if (drawerBrands) {
        drawerBrands.addEventListener('click', function (event) {
          var brandBtn = event.target.closest('[data-compare-brand]');
          if (!brandBtn) return;
          if (drawerSearch) drawerSearch.value = '';
          var brand = brandBtn.getAttribute('data-compare-brand');
          if (drawerBackLabel) drawerBackLabel.textContent = brand;
          filterBikeTiles(function (tile) {
            return tile.getAttribute('data-vendor') === brand;
          });
          showResults();
        });
      }

      if (drawerBackBtn) {
        drawerBackBtn.addEventListener('click', function () {
          if (drawerSearch) drawerSearch.value = '';
          showBrandGrid();
        });
      }

      if (drawerSearch) {
        drawerSearch.addEventListener('input', function () {
          var query = drawerSearch.value.trim();
          if (searchTimer) clearTimeout(searchTimer);
          if (query.length < 2) {
            showBrandGrid();
            return;
          }
          if (drawerBackLabel) drawerBackLabel.textContent = backLabelDefault;
          searchTimer = setTimeout(function () {
            searchStore(query);
          }, 300);
        });
      }

      drawer.addEventListener('click', function (event) {
        var pickBtn = event.target.closest('[data-compare-pick]');
        if (!pickBtn) return;
        onPick(pickBtn.getAttribute('data-compare-pick'));
        closeDrawer();
      });
    }

    /* --- Scroll progress bar (mobile) ---------------------------------------
       Same visual behavior as the previous inline script (thumb grows with
       scroll progress), but scoped per section instance and refreshed by a
       ResizeObserver so it is correct after columns are added/removed. */

    function refresh() {
      renderSlot();
      section.setAttribute('data-columns', String(1 + state.added.length));
      requestAnimationFrame(updateThumb);
    }

    function updateThumb() {
      if (!thumb) return;
      var maxScroll = scroller.scrollWidth - scroller.clientWidth;
      if (maxScroll <= 1) {
        thumb.style.width = '0';
        return;
      }
      var progress = (scroller.scrollLeft / maxScroll) * 100;
      thumb.style.width = progress + 20 + '%';
    }

    scroller.addEventListener('scroll', updateThumb, { passive: true });
    window.addEventListener('resize', updateThumb);
    window.addEventListener('load', updateThumb);
    if ('ResizeObserver' in window) {
      var observer = new ResizeObserver(updateThumb);
      observer.observe(scroller);
    }

    /* --- Bike pool (FAT-298: loaded lazily) ---------------------------------
       Every page of the pool collection's compare-json view (250 products per
       page), filtered by the current product type via the storefront filter
       param. Page 1 tells us how many pages exist.

       This used to run at init on every product page: ~500 KB of JSON parsed
       and a hidden drawer tile built for each of the ~285 bikes in the pool,
       all of it competing with the page's own rendering. The section sits far
       below the fold, so the fetch now waits until the section comes into
       view (or until the drawer is opened, whichever is first), and the drawer
       tiles are only built the first time the drawer actually opens. */

    function fetchPage(page) {
      var url =
        config.collectionUrl +
        '?view=compare-json&page=' +
        page +
        (config.productType
          ? '&filter.p.product_type=' + encodeURIComponent(config.productType)
          : '');
      return fetch(url).then(function (response) {
        if (!response.ok) throw new Error('compare-json ' + response.status);
        return response.json();
      });
    }

    var poolPromise = null;

    function loadPool() {
      if (poolPromise) return poolPromise;

      poolPromise = fetchPage(1)
        .then(function (first) {
          var requests = [Promise.resolve(first)];
          for (var page = 2; page <= first.pages; page++) requests.push(fetchPage(page));
          return Promise.all(requests);
        })
        .then(function (pages) {
          pages.forEach(function (pageData) {
            pageData.products.forEach(function (item) {
              if (item.handle === config.currentHandle) return;
              // The feed is already filtered server-side; this guard covers
              // stores where the product_type storefront filter is disabled.
              if (config.productType && item.type !== config.productType) return;
              if (byHandle[item.handle]) return;
              byHandle[item.handle] = item;
              candidates.push(item);
            });
          });

          /* Auto-populate default view: the top bikes of the same type from
             the pool (the collection's own sort order, e.g. best-selling). */
          candidates.slice(0, config.autoCount).forEach(function (candidate) {
            addColumn(candidate, true);
          });
        })
        .catch(function () {
          /* Feed unavailable: the section keeps the current product column. */
        });

      return poolPromise;
    }

    var drawerRendered = false;

    function ensureDrawerContent() {
      return loadPool().then(function () {
        if (drawerRendered) return;
        drawerRendered = true;
        renderDrawer();
      });
    }

    refresh();

    /* Warm the pool as the section approaches the viewport, so the auto
       columns are in place before the visitor reaches them and opening the
       drawer feels instant. */
    if ('IntersectionObserver' in window) {
      var poolObserver = new IntersectionObserver(
        function (entries) {
          if (!entries[0].isIntersecting) return;
          poolObserver.disconnect();
          loadPool();
        },
        { rootMargin: '800px' }
      );
      poolObserver.observe(section);
    } else {
      loadPool();
    }
  }

  function initAll() {
    document.querySelectorAll('[data-compare-section]').forEach(initSection);
  }

  initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
